<template>
    <div
        id="app"
        class="site"
        :class="{
            'site--dark': isDark,
            dimmed: isDimmed,
            locked: isLocked,
            'site--imageview': this.$route.name === 'ImageView',
        }"
    >
        <router-view
            name="navigation"
            v-if="!isDark"
            @togglePreview="togglePreview"
        />
        <main class="site-content">
            <div class="site-content__main">
                <router-view :key="$route.path" />
            </div>
            <div
                class="site-content__preview"
                v-if="!isDark"
                :class="{ visible: previewVisible }"
            >
                <router-view
                    name="preview"
                    @togglePreview="togglePreview"
                ></router-view>
            </div>
        </main>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as api from '@/api';

export default {
    created() {},
    mounted() {
        // token expired logout
        var now = parseInt(Date.now() / 1000);
        if (window.location.pathname.indexOf('admin/') >= 0) {
            if (now >= this.user.expires_at) {
                api.auth.logout();
            } else {
                if (this.$route.params.treeslug) {
                    this.$store.dispatch('loadTree', {
                        slug: this.$route.params.treeslug,
                    });
                }
            }
        }
    },
    data() {
        return {
            previewVisible: false,
        };
    },
    computed: {
        ...mapGetters(['isDimmed', 'isLocked', 'trees', 'activeTree', 'user']),
        isDark() {
            return (
                this.$route.name === 'Login' ||
                this.$route.name === 'Forgot Password' ||
                this.$route.name === 'Reset Password' ||
                this.$route.name === 'Register' ||
                this.$route.name === 'RegisterOrg'
            );
        },
    },
    watch: {
        $route(to) {
            document.title = to.meta.title || 'LOOP LinkList';
        },
        '$route.params.treeslug'(to, from) {
            if (window.location.pathname.indexOf('admin/') >= 0) {
                if (to !== from && to !== undefined) {
                    console.log('reloading da tree!');
                    this.$store.dispatch('loadTree', { slug: to });
                }
                if (to === undefined) {
                    this.$store.dispatch('clearActiveTree');
                }
            }
        },
    },
    methods: {
        togglePreview() {
            this.previewVisible = !this.previewVisible;

            this.$store.dispatch('toggleDim', this.previewVisible);
            this.$store.dispatch('toggleLock', this.previewVisible);
        },
    },
};
</script>

<style lang="scss">
.site {
    /* padding-top: $nav-height-mobile; */

    @include mq(tablet-landscape) {
        padding-top: 0;
        padding-left: $nav-width-desktop;
    }

    &--dark {
        padding: 0 !important;
        background: $almost-black;
        color: white;

        .site-content {
            display: block !important;

            &__main {
                padding-top: 0 !important;
                padding-bottom: 0 !important;
            }
        }
    }
    &--imageview {
        padding: 0;
        margin: 0;
    }

    &:after {
        content: '';
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        background: rgba(black, 0.6);
        opacity: 0;
        pointer-events: none;
        transition: all 300ms $ease-out-quad;
    }

    &.dimmed {
        &:after {
            opacity: 1;
            pointer-events: all;
            z-index: 100000;
        }
    }

    &.locked {
        position: fixed;
        left: 0;
        width: 100%;
    }
}

.site-content {
    @include mq(tablet-landscape) {
        display: flex;
        align-items: flex-start;
    }

    &__main {
        padding: 25px;

        @include mq(tablet-landscape) {
            padding: 35px 40px;
            width: 60%;
            flex-grow: 1;
        }

        @include mq(desktop) {
            padding: 60px 75px;
        }

        @include mq(notebook) {
            padding: 70px 90px;
        }

        &:only-child {
            width: 100%;
            min-height: 100vh;
        }

        .site--imageview & {
            padding: 0;
            margin: 0;
        }
    }

    &__preview {
        background: white;
        overflow: hidden;

        @include mq(tablet-landscape) {
            width: 40%;
            flex-shrink: 0;
            background: $barely-white;
            position: sticky;
            top: 0;
            right: 0;
            height: auto;
            min-height: 100vh;
            display: flex;
            align-items: center;
        }

        @include mq($until: tablet-landscape) {
            position: fixed;
            z-index: 9999999;
            top: 0;
            left: 100%;
            width: 100%;
            height: 100%;
            transition: left 800ms $ease-out-quint;
            &.visible {
                left: 0;
            }
        }

        &:empty {
            display: none;
        }
    }
}
</style>
